import React, { useState, useEffect } from 'react';
import MarkdownRenderer from '../components/MarkdownRenderer';
import LoadingState from '../components/LoadingState';
import { getPostsMetadata } from '../services/contentService';

/**
 * Standalone Welcome page component
 * Extracted from ContentViewer.js
 */
function WelcomePage() {
  const [stats, setStats] = useState(null);
  const [welcomeContent, setWelcomeContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load welcome.md file
    fetch('/welcome.md')
      .then(response => response.text())
      .then(text => {
        // Extract content after frontmatter
        const frontmatterEnd = text.indexOf('---', 3);
        const content = frontmatterEnd > 0 ? text.substring(frontmatterEnd + 3).trim() : text;
        setWelcomeContent(content);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load welcome content:', err);
        setWelcomeContent('# Welcome to Sutra\n\nYour static site generator.');
        setLoading(false);
      });

    // Load stats
    getPostsMetadata()
      .then(posts => {
        const tags = new Set();
        const categories = new Set();
        let totalWords = 0;

        posts.forEach(post => {
          if (post.tags) post.tags.forEach(tag => tags.add(tag));
          if (post.categories) post.categories.forEach(cat => categories.add(cat));
          totalWords += post.wordCount || 0;
        });

        setStats({
          posts: posts.length,
          tags: tags.size,
          categories: categories.size,
          words: totalWords
        });
      })
      .catch(err => console.error('Failed to load stats:', err));
  }, []);

  if (loading) {
    return (
      <div className="welcome-page">
        <div className="welcome-content">
          <LoadingState />
        </div>
      </div>
    );
  }

  return (
    <div className="welcome-page">
      <div className="welcome-content prose">
        <MarkdownRenderer content={welcomeContent} />

        {stats && (
          <div className="welcome-stats">
            <div className="stat-card">
              <div className="stat-value">{stats.posts}</div>
              <div className="stat-label">Posts</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.tags}</div>
              <div className="stat-label">Tags</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.categories}</div>
              <div className="stat-label">Categories</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{stats.words.toLocaleString()}</div>
              <div className="stat-label">Words Written</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WelcomePage;
